import metric100d from './data/metric-100D.json';
import metricp100d from './data/metric-P100D.json';

/**
 * Parses the data from the JSON file to a custom metric object.
 */
const parseMetric = ({ temp, wheelsize, ac, hwy }, speed = 100) => ({
  temperature: temp,
  speed: hwy.find(({ kmh }) => kmh === speed).kmh,
  kilometers: hwy.find(({ kmh }) => kmh === speed).kilometers,
  ac,
  airControl: temp >= 20 ? `ac ${ac}` : `heat ${ac}`,
  wheelsize,
});

/**
 * Custom class to manage the calculator elements with the data.
 * @class
 * @param {Number} temperature - The temperature of the vehicle.
 * @param {String} airControl - The air control of the vehicle.
 * @param {Number} wheel - The wheelsize of the vehicle.
 */
export class Calculator {
  constructor(temperature = 20, airCondition = 'off', wheel = 19) {
    this.metric100d = parseMetric(
      metric100d.find(
        ({ temp, wheelsize, ac }) =>
          temp === temperature && wheelsize === wheel && ac === airCondition
      )
    );

    this.metricp100d = parseMetric(
      metricp100d.find(
        ({ temp, wheelsize, ac }) =>
          temp === temperature && wheelsize === wheel && ac === airCondition
      )
    );

    this.temperature = temperature;
    this.speed = this.metric100d.speed;
    this.wheelsize = wheel;
    this.airControl = this.metric100d.airControl;
  }

  /**
   * Performs syncronization between the calculator and the JSON metrics.
   */
  syncFromMetric() {
    this.metric100d = parseMetric(
      metric100d.find(
        ({ temp, wheelsize, ac }) =>
          temp === this.temperature &&
          wheelsize === this.wheelsize &&
          ac === this.metric100d.ac
      ),
      this.speed
    );
    this.metricp100d = parseMetric(
      metricp100d.find(
        ({ temp, wheelsize, ac }) =>
          temp === this.temperature &&
          wheelsize === this.wheelsize &&
          ac === this.metricp100d.ac
      ),
      this.speed
    );
    this.airControl =
      this.temperature >= 20
        ? `ac ${this.metric100d.ac}`
        : `heat ${this.metric100d.ac}`;
  }

  /**
   * Toggles the air control of the vehicles.
   */
  toggleAirControl() {
    this.metric100d.ac = this.metric100d.ac === 'off' ? 'on' : 'off';
    this.metricp100d.ac = this.metricp100d.ac === 'off' ? 'on' : 'off';
    this.syncFromMetric();
  }

  /**
   * Increments the temperature of the vehicles.
   */
  increaseTemperature() {
    this.temperature += 10;
    this.syncFromMetric();
  }

  /**
   * Decrements the temperature of the vehicles.
   */
  decreaseTemperature() {
    this.temperature -= 10;
    this.syncFromMetric();
  }

  /**
   * Increments the speed of the vehicles.
   */
  increaseSpeed() {
    this.speed += 10;
    this.syncFromMetric();
  }

  /**
   * Decrements the speed of the vehicles.
   */
  decreaseSpeed() {
    this.speed -= 10;
    this.syncFromMetric();
  }

  /**
   * Changes the wheel size of the vehicles.
   * @param {Number} size : The new wheelsize of the vehicle.
   */
  changeWheelSize(size) {
    this.wheelsize = size;
    this.syncFromMetric();
  }
}
